import create from 'zustand';

interface StoreState {
  bioAvailable: boolean;
  bioInited: boolean;
  bioAccessGranted: boolean;
  paymentPwdExists: number;
  userLocking: boolean;
  setBioAvailable: (bool: boolean) => void;
  setBioInited: (bool: boolean) => void;
  setBioAccessGranted: (bool: boolean) => void;
  setPaymentPwdExists: (bool: number) => void;
}

const useStore = create<StoreState>(set => ({
  bioAvailable: false,
  bioInited: false,
  bioAccessGranted: false,
  paymentPwdExists: -1,
  userLocking: true,
  setBioAvailable: (bioAvailable: boolean) =>
    set({ bioAvailable: bioAvailable }),
  setBioInited: (bioInited: boolean) => set({ bioInited: bioInited }),
  setBioAccessGranted: (bioAccessGranted: boolean) =>
    set({ bioAccessGranted: bioAccessGranted }),
  setPaymentPwdExists: (paymentPwdExists: number) =>
    set({ paymentPwdExists: paymentPwdExists }),
}));

export default useStore;
